module.exports = __webpack_public_path__ + "img/content_pic04.85fc7921.jpg";